module.exports = __webpack_public_path__ + "img/hdd.bb5b41e1.svg";